import { render } from "./Metric.vue?vue&type=template&id=6c8a6574&scoped=true"
import script from "./Metric.vue?vue&type=script&lang=js"
export * from "./Metric.vue?vue&type=script&lang=js"

import "./Metric.vue?vue&type=style&index=0&id=6c8a6574&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8a6574"]])

export default __exports__